'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    @media (min-width: ', 'px) {\n      ', ';\n    }\n  '], ['\n    @media (min-width: ', 'px) {\n      ', ';\n    }\n  ']);

var _polished = require('polished');

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var sizes = {
  xl: 1600,
  l: 1050,
  m: 768,
  s: 480,
  xs: 320
};
var media = {
  s: function s() {
    return (0, _styledComponents.css)(_templateObject, sizes.s, _styledComponents.css.apply(undefined, arguments));
  },
  m: function m() {
    return (0, _styledComponents.css)(_templateObject, sizes.m, _styledComponents.css.apply(undefined, arguments));
  },
  l: function l() {
    return (0, _styledComponents.css)(_templateObject, sizes.l, _styledComponents.css.apply(undefined, arguments));
  },
  xl: function xl() {
    return (0, _styledComponents.css)(_templateObject, sizes.xl, _styledComponents.css.apply(undefined, arguments));
  }
};
var color = {
  base: '#555555',
  primary: '#1D71B8',
  primaryBg: '#FFF',
  danger: '#e94141',
  dangerBg: 'rgba(255,0,0,0.1)',
  dangerPopup: 'rgba(255,0,0,0.5)',
  success: '#5bd084',
  successBg: '#e8fff0',
  fadedText: '#aaa',
  disabled: '#f1f1f1',
  fadedBase: '#55555544',
  fadedPrimary: '#e0ecf6'
};
var form = {
  labelColor: color.base,
  placeholderColor: '#ccc'
};
var select = {
  placeholderColor: '#ccc',
  darkerBg: '#f9f9f9'
};
var table = {
  headerBg: '#f9f9f9',
  evenRow: color.base,
  evenRowBg: '#f9f9f9',
  oddRow: color.base,
  oddRowBg: '#ffffff',
  hover: '#f2f2f2',
  fontSize: '11px',
  activeRow: color.base,
  activeRowBg: color.primaryBg,
  highlightRow: color.base,
  highlightRowBg: color.successBg
};
var grid = {
  gutterWidth: '0 ' + (0, _polished.rem)(10)
};
var chart = {
  pieColors: ['#ed1c24', '#aecb4c', '#0061aa', '#fdc010', '#00ab4e'],
  colors: ['#1D71B8', '#D7D7D7'],
  colorOfBrand: {
    TIKKURILA: '#ed1c24',
    FINKOLORA: '#aecb4c',
    ZORKA: '#d0112b',
    'INTERNAL ITEMS': '#e7131f',
    ANZA: '#000002',
    MASTON: '#0061aa',
    TEKNOS: '#00ab4e',
    MIRKA: '#fdc010'
  }
};
var theme = {
  chart: chart,
  color: color,
  form: form,
  table: table,
  select: select,
  media: media,
  grid: grid,
  textColor: color.base,
  inactiveColor: 'rgba(29, 113, 184, 0.3)',
  separatorColor: '#eee',
  baseBorderRadius: (0, _polished.rem)(3),
  largeBorderRadius: (0, _polished.rem)(4),
  fontFamily: '\'Roboto\', sans-serif',
  backgroundColor: '#fff',
  focusShadow: '0 0 1px 1px ' + color.primary + '66',
  disabledFormColor: '#f9f9f9',
  shadow: '0 ' + (0, _polished.rem)(3) + ' ' + (0, _polished.rem)(12) + ' ' + color.primary + '66',
  smallShadow: '0 0 1px 1px ' + color.fadedBase,
  shadowInactive: '0 ' + (0, _polished.rem)(3) + ' ' + (0, _polished.rem)(12) + ' rgba(204, 204, 204, 1)',
  // focusShadow: `0 0 ${rem(20)} 0 ${color.inactive}`,
  border: '2px solid ' + color.primary,
  bigFontSize: (0, _polished.rem)(20)
};
exports.default = theme;